import PropTypes from 'prop-types';
import SportWatermarkImageImpl from './sport-watermark-image';
import MojitoCore from 'mojito/core';

/**
 * The Sport Watermark Image component is used to display sport image background on the event cards.
 *
 * @class SportWatermarkImage
 * @memberof Mojito.Presentation.Components
 */

/**
 * Prop types for the SportWatermarkImage component.
 *
 * @property {string} [sportId] - Sport id to present image for.
 * @property {string} [position] - Position of the watermark image. If provided then it will apply corresponding image container styles from the config to position the image in a correct corner of the component.
 * If not provided then config.imageContainer will be applied.
 *
 * @memberof Mojito.Presentation.Components.SportWatermarkImage
 */
const propTypes = {
    sportId: PropTypes.string,
    position: PropTypes.string,
};

export default MojitoCore.Presentation.UIView(
    'SportWatermarkImage',
    SportWatermarkImageImpl,
    propTypes
);
